module.exports = __webpack_public_path__ + "static/media/41.94d9ba90.mp3";